/* eslint-disable */
/* tslint:disable */

import React, { useEffect, useState } from 'react';
import { Layout, message } from 'antd';
import { observer } from 'mobx-react';
import { Menu, Dropdown } from 'antd';
import logo from '../../images/icon/cloud.svg';
import search from '../../images/icon/search.svg';
import dataLogo from '../../images/data-logo.png';
import headerLogo from '../../images/headerLogo.png';
import footerLogo from '../../images/footerLogo.png';
import userLogin from '../../images/user.svg';
import Dialog from '../dialog/dialog';
import Login from '../../features/user/login/login';
import { getEnv } from '../../helpers/mobx-easy-wrapper';
import Banner from '../../features/activity/banner';
import { isNumber } from '../../utils/NumberUtil';

const Header = () => {
  const [logined, setLogined] = useState(false);
  const [user, setUser] = useState();
  const [showLogin, setShowLogin] = useState(false);
  const [enter, setEnter] = useState('enterprise');

  const { apiFactory } = getEnv();
  useEffect(() => {
    const loginFlag = apiFactory.authService.isAuthenticated();
    if (loginFlag) {
      const user = apiFactory.authService.getLoginUser();
      setUser(user);
    }
    async function getDetail() {
      const result = await apiFactory.activityService.getWorksDetail();

      if (result && result.type === '高校') {
        setEnter('college');
        (window as any)['enter'] = 'college';
      }

      if (result && isNumber(result.status)) {
        (window as any)['enterStatus'] = result.status;
      }
    }
    getDetail();
    setLogined(loginFlag);
  }, []);

  const logout = () => {
    apiFactory.authService.logout();
    message.success('注销成功');
    setTimeout(() => {
      window.location.reload();
    }, 600);
  };

  // @ts-ignore
  const menu = (
    <Menu>
      <Menu.Item key="1">
        <label>注销</label>
      </Menu.Item>
      {/*        <Menu.SubMenu key="SubMenu" title="Navigation Three - Submenu" icon={<SettingOutlined />}>
          <Menu.ItemGroup title="Item 1">
            <Menu.Item key="app" icon={<AppstoreOutlined />}>
              Navigation Two
            </Menu.Item>
            <Menu.Item key="disabled" disabled>
              Navigation Three
            </Menu.Item>
          </Menu.ItemGroup>
        </Menu.SubMenu>*/}
    </Menu>
  );

  return (
    <Layout.Header
      className="header App"
      style={{paddingTop: 25, paddingBottom: 25}}
      onMouseLeave={() => {
        (document.querySelector('.header') as HTMLDivElement).classList.remove(
          'leave'
        );
        (
          document.querySelector('.header') as HTMLDivElement
        ).style.removeProperty('transform');
      }}
    >
      <ul className="container">
        <li>
          {' '}
          <img
            className="logo"
            src={headerLogo}
            onClick={() => (location.href = '/expert/home')}
            style={{
              width: '350px',
              height: 'auto',
              float: 'left',
              marginRight: '35px',
            }}
          />{' '}
        </li>
        <li style={{ margin: '0 auto' }}>

        </li>

        <li className="container__item--right">
          <div
            id="loginHeader"
            className="user"
            style={{
              width: 200,
              lineHeight: '65px'
            }}
            onClick={() => {
              !logined && (location.href='/expert/login');
            }}
          >
            {/* <div className={`${logined ? 'dropdown' : ''}`}> */}
            <div className={`dropdown`}>
              {logined ? (
                <>
                  <label style={{width: 195}}>欢迎，专家 {user && (user! as any).name} &nbsp;&nbsp;&nbsp;<a onClick={logout}>退出</a></label>
                 {/* <div className="dropdown__content">
                    <div
                      className="logout"
                      style={{ marginTop: '8px' }}

                    >
                      注销
                    </div>
                  </div>*/}
                </>
              ) : (
                <>
                  <label>用户登录</label>
                </>
              )}
            </div>
          </div>
        </li>
      </ul>

      {showLogin && (
        <Dialog>
          <Login
            closeEvent={() => {
              setShowLogin(false);
            }}
          />
        </Dialog>
      )}
    </Layout.Header>
  );
};

export default observer(Header);
